/**
 * 画像のlightbox対応
 */
import { Luminous, LuminousGallery } from "luminous-lightbox";
export default () => {
  // 画像リンクのライトボックス対応
  const zoomItems = document.querySelectorAll(".js-zoom");
  zoomItems.forEach((zoomItem) => {
    new Luminous(zoomItem);
  });

  const wpGallery = document.querySelectorAll(
    ".wp-block-gallery .wp-block-image>a"
  );
  if (wpGallery) {
    const options = {};
    new LuminousGallery(wpGallery);
  }

  // 汎用ギャラリー
  const gallery = document.querySelectorAll(".js-gallery a");
  if (gallery) {
    const options = {};
    new LuminousGallery(gallery);
  }
};
